import React, { useState } from "react";
import { createItem } from "./api";
import { GiSplitCross } from "react-icons/gi";
import { toast } from "react-toastify";
import { FaPlus, FaMinus } from "react-icons/fa";
import axios from "axios";

const AddItemForm = ({ onAdd, setShowForm }) => {
  const [formData, setFormData] = useState({
    itemName: "",
    grossWeight: "",
    goldRate: "",
    netGoldWeight: "",
 
    stoneType: [{ type: "", weight: "", rate: "" }],
    diamondType: [{ type: "", weight: "", rate: "" }],

    laborCharge: "",
    totalRate: "",
    image: null,
    image2: null,
    video: null,
    category: "",
    caratTypes:""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [imagePreviews, setImagePreviews] = useState([]);

  const handleStoneChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newStones = [...prevFormData.stoneType];
      newStones[index][name] = value;
      return { ...prevFormData, stoneType: newStones };
    });
  };
  console.log(formData, "");
  const handleDiamondChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newDiamonds = [...prevFormData.diamondType];
      newDiamonds[index][name] = value;
      return { ...prevFormData, diamondType: newDiamonds };
    });
  };

  const addStone = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      stoneType: [
        ...prevFormData.stoneType,
        { type: "", weight: "", rate: "" },
      ],
    }));
  };
  const addDiamond = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      diamondType: [
        ...prevFormData.diamondType,
        { type: "", weight: "", rate: "" },
      ],
    }));
  };

  const removeStone = (index) => {
    setFormData((prevFormData) => {
      const newStones = [...prevFormData.stoneType];
      newStones.splice(index, 1);
      return { ...prevFormData, stoneType: newStones };
    });
  };
  const removeDiamond = (index) => {
    setFormData((prevFormData) => {
      const newDiamonds = [...prevFormData.diamondType];
      newDiamonds.splice(index, 1);
      return { ...prevFormData, diamondType: newDiamonds };
    });
  };

  const handleCancel = () => {
    setShowForm(false);
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      if (name === "image" || name === "image2") {
        const file = files[0];
        setFormData({
          ...formData,
          [name]: file,
        });
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreviews((prev) => [...prev, reader.result]);
        };
        reader.readAsDataURL(file);
      } else {
        setFormData({
          ...formData,
          [name]: files[0],
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const formDataSend = new FormData();

      // Append fields
      formDataSend.append("itemName", formData.itemName || "");
      formDataSend.append("grossWeight", formData.grossWeight || "");
      formDataSend.append("goldRate", formData.goldRate || "");
      formDataSend.append("netGoldWeight", formData.netGoldWeight || "");
    
     
      formDataSend.append("laborCharge", formData.laborCharge || "");
      formDataSend.append("totalRate", formData.totalRate || "");
      formDataSend.append("category", formData.category || "");
      formDataSend.append("caratTypes", formData.caratTypes || "");
      formDataSend.append(
        "stoneType",
        JSON.stringify(formData.stoneType || [])
      );
      formDataSend.append(
        "diamondType",
        JSON.stringify(formData.diamondType || [])
      );
      if (formData.image) {
        formDataSend.append("image", formData.image);
      }
      if (formData.image2) {
        formDataSend.append("image2", formData.image2);
      }
      if (formData.video) {
        formDataSend.append("video", formData.video);
      }

   

      const response = await createItem(formDataSend);

      console.log("API Response:", response); 

      toast.success("Item added successfully");
      setShowForm(false);
      setLoading(false);
      
    } catch (error) {
      console.error("Error during form submission:", error); // Log error details
      setError("Failed to create item. Please check the inputs and try again.");
      setLoading(false);
    }
  };

 

  return loading ? (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white bg-opacity-80 z-50">
      <div className="flex flex-col items-center gap-2">
        <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-green-600"></div>
        <h1 className="text-xl text-green-600 font-medium">
          Please Wait .......
        </h1>
      </div>
    </div>
  ) : (
    <form
      className="bg-white shadow-md rounded-lg p-4 w-full lg:px-5 mx-auto z-30"
      onSubmit={handleSubmit}
    >
      <div className="flex justify-between w-full items-center">
        <h2 className="text-lg font-bold mb-4">Add New Item</h2>
        <GiSplitCross
          onClick={handleCancel}
          className="text-lg font-bold mb-4 cursor-pointer"
        />
      </div>
      {error && <div className="text-red-500 mb-4">{error}</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-gray-700 capitalize">Item Name <span className=" text-xl text-red-700">*</span></label>
          <input
            type="text"
            name="itemName"
            value={formData.itemName}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg"
            placeholder="Enter item name"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 capitalize">Category  <span className=" text-xl text-red-700">*</span></label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg"
            required
          >
            <option value="">Select Category</option>
            <option value="EarRing">Ear Ring</option>
            <option value="Necklace">Necklace</option>
            <option value="Ring">Finger Ring</option>
            <option value="Ring">Bracelet</option>
            <option value="Ring">Bangles</option>
            <option value="Ring">Pendant</option>

          </select>
        </div>
      </div>

      {/* Gold Section */}
      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Gold Details</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
         
          <div>
            <label className="block text-gray-700 capitalize">Gold Rate   <span className=" text-xl text-red-700">*</span></label>
            <input
              type="number"
              name="goldRate"
              value={formData.goldRate}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter gold rate"
              step="0.01"
              min="0"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 capitalize">
              Net Gold Weight  <span className=" text-xl text-red-700">*</span>
            </label>
            <input
              type="number"
              name="netGoldWeight"
              value={formData.netGoldWeight}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter net gold weight in gram"
              step="0.01"
              min="0"
              required
            />
          </div>
          <div>
          <label className="block text-gray-700 capitalize">Gold Purity</label>
          <select
            name="caratTypes"
            value={formData.caratTypes}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg"
            required
          >
            <option value="">Select</option>
            <option value="16">16 carat</option>
            <option value="18">18 carat</option>
            <option value="20">20 carat</option>
            <option value="22">22 carat</option>
            <option value="24">24 carat</option>
          </select>
        </div>
        </div>
      </div>

      {/* Diamond Section */}
      {/* <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Diamond Details</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-gray-700 capitalize">
              Round Diamond Weight  <span className=" text-xl text-red-700">*</span>
            </label>
            <input
              type="number"
              name="roundDiamondWeight"
              value={formData.roundDiamondWeight}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter round diamond weight"
              step="0.01"
              min="0"
            />
          </div>
          <div>
            <label className="block text-gray-700 capitalize">
              Round Diamond Rate  <span className=" text-xl text-red-700">*</span>
            </label>
            <input
              type="number"
              name="roundDiamondRate"
              value={formData.roundDiamondRate}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter round diamond rate"
              step="0.01"
              min="0"
            />
          </div>
          <div>
            <label className="block text-gray-700 capitalize">
              Polki Diamond Weight  <span className=" text-xl text-red-700">*</span>
            </label>
            <input
              type="number"
              name="polkiDiamondWeight"
              value={formData.polkiDiamondWeight}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter polki diamond weight"
              step="0.01"
              min="0"
            />
          </div>
          <div>
            <label className="block text-gray-700 capitalize">
              Polki Diamond Rate  <span className=" text-xl text-red-700">*</span>
            </label>
            <input
              type="number"
              name="polkiDiamondRate"
              value={formData.polkiDiamondRate}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter polki diamond rate"
              step="0.01"
              min="0"
            />
          </div>
        </div>
      </div> */}
       {/* Diamond Section */}
      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Diamond Details</h3>
        {formData.diamondType.map((diamond, index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3"
          >
            <div>
              <label className="block text-gray-700 capitalize">Type  <span className=" text-xl text-red-700">*</span></label>
              <input
                type="text"
                name="type"
                value={diamond.type}
                onChange={(e) => handleDiamondChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone type"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 capitalize">Weight  <span className=" text-xl text-red-700">*</span></label>
              <input
                type="number"
                name="weight"
                value={diamond.weight}
                onChange={(e) => handleDiamondChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone weight in carat"
                step="0.01"
                min="0"
                required
              />
            </div>
         
            <div className="flex items-center ">
             <div className=" flex w-full flex-col items-start justify-start">
             <label className="block text-gray-700  capitalize">Rate  <span className=" text-xl text-red-700">*</span></label>
              <input
                type="number"
                name="rate"
                value={diamond.rate}
                onChange={(e) => handleDiamondChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone rate"
                step="0.01"
                min="0"
                required
              />
             </div>
              <button
                type="button"
                onClick={() => removeDiamond(index)}
                className="ml-3 md:w-[3vh] w-[25px] mt-5 bg-red-500 text-white p-1 rounded-lg"
              >
                <FaMinus />
              </button>
            </div>
          </div>
        ))}
        <button
          type="button"
          onClick={addDiamond}
          className="bg-blue-500 text-white p-2 rounded-lg mt-4"
        >
         <div className=" flex items-center justify-center p-1 gap-2 text-lg"> <FaPlus /> Add Diamond</div>
        </button>
      </div>
      {/* Stone Section */}
      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Stone Details</h3>
        {formData.stoneType.map((stone, index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3"
          >
            <div>
              <label className="block text-gray-700 capitalize">Type  <span className=" text-xl text-red-700">*</span></label>
              <input
                type="text"
                name="type"
                value={stone.type}
                onChange={(e) => handleStoneChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone type"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 capitalize">Weight  <span className=" text-xl text-red-700">*</span></label>
              <input
                type="number"
                name="weight"
                value={stone.weight}
                onChange={(e) => handleStoneChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone weight in carat"
                step="0.01"
                min="0"
                required
              />
            </div>
            <div className="flex items-center ">
             <div className=" flex w-full flex-col items-start justify-start">
             <label className="block text-gray-700  capitalize">Rate  <span className=" text-xl text-red-700">*</span></label>
              <input
                type="number"
                name="rate"
                value={stone.rate}
                onChange={(e) => handleStoneChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone rate"
                step="0.01"
                min="0"
                required
              />
             </div>
              <button
                type="button"
                onClick={() => removeStone(index)}
                className="ml-3 md:w-[3vh] w-[25px] mt-5 bg-red-500 text-white p-1 rounded-lg"
              >
                <FaMinus />
              </button>
            </div>
          </div>
        ))}
         <button
          type="button"
          onClick={addStone}
          className="bg-blue-500 p-2 text-white rounded-lg mt-4"
        >
         <div className=" flex items-center justify-center p-1 gap-2 text-lg"> <FaPlus /> Add Stone</div>
        </button>
      </div>
       
      {/* Additional Fields */}
      <div className="mt-6 ">
      <h3 className="text-xl pb-3 font-semibold">Additional Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">

<div>
  <label className="block text-gray-700 capitalize">Labor Charge  <span className=" text-xl text-red-700">*</span></label>
  <input
    type="number"
    name="laborCharge"
    value={formData.laborCharge}
    onChange={handleChange}
    className="w-full p-2 border border-gray-300 rounded-lg"
    placeholder="Enter labor charge"
    step="0.01"
    min="0"
    required
  />
</div>
<div>
    <label className="block text-gray-700 capitalize">
      Gross Weight  <span className=" text-xl text-red-700">*</span>
    </label>
    <input
      type="number"
      name="grossWeight"
      value={formData.grossWeight}
      onChange={handleChange}
      className="w-full p-2 border border-gray-300 rounded-lg"
      placeholder="Enter gross weight in gram"
      step="0.01"
      min="0"
      required
    />
  </div>
<div>
  <label className="block text-gray-700 capitalize">Total Rate  <span className=" text-xl text-red-700">*</span></label>
  <input
    type="number"
    name="totalRate"
    value={formData.totalRate}
    onChange={handleChange}
    className="w-full p-2 border border-gray-300 rounded-lg"
    placeholder="Enter total rate"
    step="0.01"
    min="0"
    required
  />
</div>
</div>
      </div>
     

      {/* File Upload Section */}
      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Upload Media</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-gray-700 capitalize">Image 1  <span className=" text-xl text-red-700">*</span></label>
            <input
              type="file"
              name="image"
              accept="image/*"
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              required
            />
            {imagePreviews[0] && (
              <img
                src={imagePreviews[0]}
                alt="Preview"
                className="mt-2 h-20 w-20 object-cover"
              />
            )}
          </div>
          <div>
            <label className="block text-gray-700 capitalize">Image 2</label>
            <input
              type="file"
              name="image2"
              accept="image/*"
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
            />
            {imagePreviews[1] && (
              <img
                src={imagePreviews[1]}
                alt="Preview"
                className="mt-2 h-20 w-20 object-cover"
              />
            )}
          </div>
          <div>
            <label className="block text-gray-700 capitalize">Video</label>
            <input
              type="file"
              name="video"
              accept="video/*"
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
            />
          </div>
        </div>
      </div>

      <div className="mt-5 flex justify-center md:justify-end">
        <button
          type="submit"
          className="bg-green-600 md:mr-20 text-lg text-white p-2 px-28 rounded-lg"
        >
          Submit
        </button>
      </div>
    </form>
  );
};

export default AddItemForm;
